import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MdEmail } from "react-icons/md";
import { RiLockPasswordFill } from "react-icons/ri";
import { FaUserCircle } from "react-icons/fa";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { toast } from "react-toastify";
import logo from "../asset/logowhite.png";
import loginbg from "../asset/login/login.png";
import SummaryApi from "../common";
import { FaArrowLeft } from "react-icons/fa";
const InstructorLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
const [formData, setFormData] = useState({
  email: "", // Remove sessionStorage.getItem("login_identifier") || ""
  password: "",
});
useEffect(() => {
  // Clear any stored email from session storage when component loads
  sessionStorage.removeItem("login_identifier");
  
  if (location.state?.from) {
    toast.info("Please log in to continue");
  }
}, [location.state]);

useEffect(() => {
  const verifySession = async () => {
    const instructorId = sessionStorage.getItem("instructor_id");
    const loginIdentifier = sessionStorage.getItem("login_identifier");
    const sessionToken = sessionStorage.getItem("H7Z4L9VD2XK5JW8QRYT6");

    // If no session → do nothing silently
    if (!instructorId || !loginIdentifier || !sessionToken) return;

    setIsLoading(true);
    try {
      const response = await fetch(SummaryApi.instructorLogin.url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: loginIdentifier }),
      });
      const data = await response.json();

      if (!data.status || data.data?.is_active !== 1 || data.data?.is_otp_verification !== 1) {
        // Silent cleanup — DO NOT show toast error here!
        sessionStorage.clear();
        return;
      }

      // Valid session → redirect silently
      toast.info("Welcome back!");
      navigate("/instructor-panel/dashboard", { replace: true });

    } catch (error) {
      console.error("Silent session check failed:", error);
      sessionStorage.clear(); // Silent fail
    } finally {
      setIsLoading(false);
    }
  };

  verifySession();
}, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const checkInstructorStatus = async (email) => {
    const login_identifier = email;
    try {
      const res = await fetch(SummaryApi.instructorLoginStatus.url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ login_identifier }),
      });
      return await res.json();
    } catch (error) {
      console.error("Instructor status check failed:", error);
      return null;
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const { email, password } = formData;

  //   if (!email || !password) {
  //     toast.error("Please fill in all fields");
  //     return;
  //   }

  //   setIsLoading(true);
  //   try {
  //     const res = await fetch(SummaryApi.instructorLogin.url, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ email, password }),
  //     });

  //     const data = await res.json();

  //     if (!data.status) {
  //       if (data.message === "Invalid email or password or account not active") {
  //         toast.error("Invalid credentials. Please try again.");

  //         const statusCheck = await checkInstructorStatus(email);

  //         if (!statusCheck || !statusCheck.data) {
  //           toast.error("Email not found. Please check your credentials.");
  //         } else if (
  //           statusCheck.data.is_active === 0 &&
  //           statusCheck.data.is_otp_verification === 1
  //         ) {
  //           toast.error("Account inactive. Access denied.");
  //           setTimeout(() => {
  //             navigate("/instructor-access-denied", { replace: true });
  //           }, 500);
  //         }

  //         setIsLoading(false);
  //         return;
  //       }

  //       if (data.instructor_id && data.is_active === 0) {
  //         sessionStorage.setItem("login_identifier", email);
  //         sessionStorage.setItem("instructor_id", data.instructor_id);
  //         sessionStorage.setItem("H7Z4L9VD2XK5JW8QRYT6", "pending_activation");
  //         toast.info("Please complete your profile to activate your account");

  //         const encodedInstructorId = btoa(data.instructor_id.toString());
  //         setTimeout(() => {
  //           navigate(
  //             `/instructor-panel/edit-instructor?id=${encodeURIComponent(encodedInstructorId)}`,
  //             { replace: true }
  //           );
  //         }, 500);
  //       } else {
  //         toast.error(data.message || "Login failed. Please try again.");
  //       }

  //       setIsLoading(false);
  //       return;
  //     }

  //     if (data.is_active === 1 && data.is_otp_verification === 1) {
  //       sessionStorage.setItem("login_identifier", data.email);
  //       sessionStorage.setItem("instructor_id", data.instructor_id);
  //       sessionStorage.setItem("H7Z4L9VD2XK5JW8QRYT6", "active");
  //       toast.success(data.message || "Login successful!");
  //       navigate("/instructor-panel/dashboard", { replace: true });
  //     } else if (data.is_active === 0 && data.is_otp_verification === 0) {
  //       toast.info("Please verify your account to proceed.");
  //       setTimeout(() => {
  //         navigate("/instructor-verification", {
  //           state: { login_identifier: email },
  //           replace: true,
  //         });
  //       }, 500);
  //     } else if (data.is_active === 0 && data.is_otp_verification === 1) {
  //       if (data.instructor_id) {
  //         sessionStorage.setItem("login_identifier", email);
  //         sessionStorage.setItem("instructor_id", data.instructor_id);
  //         sessionStorage.setItem("H7Z4L9VD2XK5JW8QRYT6", "pending_activation");

  //         toast.info("Please complete your profile to activate your account");

  //         const encodedInstructorId = btoa(data.instructor_id.toString());
  //         setTimeout(() => {
  //           navigate(
  //             `/instructor-panel/edit-instructor?id=${encodeURIComponent(encodedInstructorId)}`,
  //             { replace: true }
  //           );
  //         }, 500);
  //       } else {
  //         toast.error("Your account is inactive. Please contact admin.");
  //         setTimeout(() => {
  //           navigate("/instructor-access-denied", {
  //             state: { reason: "Account is inactive. Please contact admin." },
  //             replace: true,
  //           });
  //         }, 500);
  //       }
  //     } else {
  //       toast.error(data.message || "Invalid credentials or account status.");
  //       setTimeout(() => {
  //         navigate("/instructor-access-denied", {
  //           state: { reason: "Invalid credentials or account status." },
  //           replace: true,
  //         });
  //       }, 500);
  //     }
  //   } catch (error) {
  //     console.error("Login error:", error);
  //     toast.error("Something went wrong. Please try again.");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const { email, password } = formData;

//     if (!email || !password) {
//       toast.error("Please fill in all fields");
//       return;
//     }

//     setIsLoading(true);
//     try {
//       const res = await fetch(SummaryApi.instructorLogin.url, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email, password }),
//       });

//       const data = await res.json();

// // LOGIN FAILED
// if (!data.status) {
//   // ONLY when this exact message comes → check status API
//   if (data.message === "Invalid email or password or account not active") {
//     const statusCheck = await checkInstructorStatus(email);

//     // If status API says account is already ACTIVE → password is wrong
//     if (statusCheck?.status && statusCheck.data?.is_active === 1 && statusCheck.data?.is_otp_verification === 1) {
// setIsLoading(false);
// toast.error("Invalid password", { autoClose: 600 });

//       return; // stop further execution
//     }

//     // If account is profile incomplete → go to edit profile
//     if (statusCheck?.data?.is_active === 0 && statusCheck?.data?.is_otp_verification === 1) {
//       sessionStorage.setItem("login_identifier", email);
//       sessionStorage.setItem("instructor_id", statusCheck.data.instructor_id);
//       sessionStorage.setItem("H7Z4L9VD2XK5JW8QRYT6", "pending_activation");

//       const encodedInstructorId = btoa(statusCheck.data.instructor_id.toString());
//       setIsLoading(false); // stop loader BEFORE navigate
//       navigate(
//         `/instructor-panel/edit-instructor?id=${encodeURIComponent(encodedInstructorId)}`,
//         { replace: true }
//       );
//       return;
//     }
//   }

//   setIsLoading(false); // stop loader
//   toast.error(data.message || "Invalid credentials. Please try again.");
//   return;
// }


//       // LOGIN SUCCESS
//       if (data.is_active === 1 && data.is_otp_verification === 1) {
//         sessionStorage.setItem("login_identifier", data.email);
//         sessionStorage.setItem("instructor_id", data.instructor_id);
//         sessionStorage.setItem("H7Z4L9VD2XK5JW8QRYT6", "active");
//         if (data.mobile_number) {
//           sessionStorage.setItem("instructor_mobile", data.mobile_number);
//         }
// toast.success(data.message || "Login successful!", {
//   autoClose: 800,
//   pauseOnFocusLoss: false,
//   closeOnClick: false,
// });

// setTimeout(() => {
//   navigate("/instructor-panel/dashboard", { replace: true });
// }, 900);



//       } else if (data.is_active === 0 && data.is_otp_verification === 0) {
//         sessionStorage.setItem("login_identifier", email);
//         toast.info("Please verify your account to proceed.");
//         setTimeout(() => {
//           navigate("/instructor-verification", {
//             state: { login_identifier: email },
//             replace: true,
//           });
//         }, 500);

//       } else if (data.is_active === 0 && data.is_otp_verification === 1) {
//         sessionStorage.setItem("login_identifier", email);
//         sessionStorage.setItem("instructor_id", data.instructor_id);
//         sessionStorage.setItem("H7Z4L9VD2XK5JW8QRYT6", "pending_activation");
//         if (data.mobile_number) {
//           sessionStorage.setItem("instructor_mobile", data.mobile_number);
//         }

//         const encodedInstructorId = btoa(data.instructor_id.toString());
//         setTimeout(() => {
//           navigate(
//             `/instructor-panel/edit-instructor?id=${encodeURIComponent(encodedInstructorId)}`,
//             { replace: true }
//           );
//         }, 100);

//       } else {
//         toast.error("Account status invalid. Please contact admin.");
//         navigate("/instructor-access-denied", { replace: true });
//       }

//     } catch (error) {
//       console.error("Login error:", error);
//       toast.error("Something went wrong. Please try again.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

const handleSubmit = async (e) => {
  e.preventDefault();
  const { email, password } = formData;

  if (!email || !password) {
    toast.error("Please fill in all fields");
    return;
  }

  setIsLoading(true);

  try {
    // Step 1: Try Login
    const loginResponse = await fetch(SummaryApi.instructorLogin.url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });

    const loginData = await loginResponse.json();

    // ========================================
    // CASE 1: LOGIN FAILED (status === false)
    // ========================================
    if (!loginData.status) {
      // Only handle the specific message we expect
      if (loginData.message === "Invalid email or password or account not active") {
        // Call status check API to know user's current state
        const statusCheck = await checkInstructorStatus(email);

        // Sub-case A: User exists + fully active → means password is wrong!
        if (
          statusCheck?.status &&
          statusCheck.data?.is_active === 1 &&
          statusCheck.data?.is_otp_verification === 1
        ) {
          setIsLoading(false);
          toast.error("Invalid password", { autoClose: 4000 });
          return;
        }

        // Sub-case B: Profile incomplete (OTP done, but not activated)
        if (
          statusCheck?.data?.is_active === 0 &&
          statusCheck.data?.is_otp_verification === 1
        ) {
          sessionStorage.setItem("login_identifier", email);
          sessionStorage.setItem("instructor_id", statusCheck.data.instructor_id);
          sessionStorage.setItem("H7Z4L9VD2XK5JW8QRYT6", "pending_activation");

          const encodedId = btoa(statusCheck.data.instructor_id.toString());
          toast.info("Please complete your profile to activate account");
          setTimeout(() => {
            navigate(
              `/instructor-panel/edit-instructor?id=${encodeURIComponent(encodedId)}`,
              { replace: true }
            );
          }, 600);
          return;
        }
      }

      // Any other failure (wrong email, blocked, etc.)
      setIsLoading(false);
      toast.error("Invalid credentials or account not active");
      return;
    }

    // ========================================
    // CASE 2: LOGIN SUCCESS (status === true)
    // ========================================
    if (loginData.status === true) {
      const user = loginData.data || loginData; // fallback if structure varies

      // Fully Active → Go to Dashboard
      if (user.is_active === 1 && user.is_otp_verification === 1) {
        sessionStorage.setItem("login_identifier", user.email || email);
        sessionStorage.setItem("instructor_id", user.instructor_id);
        sessionStorage.setItem("H7Z4L9VD2XK5JW8QRYT6", "active");
        if (user.mobile_number) {
          sessionStorage.setItem("instructor_mobile", user.mobile_number);
        }

        toast.success("Login successful! Welcome back", { autoClose: 1000 });
        setTimeout(() => {
          navigate("/instructor-panel/dashboard", { replace: true });
        }, 1100);
        return;
      }

      // OTP Not Verified
      if (user.is_active === 0 && user.is_otp_verification === 0) {
        sessionStorage.setItem("login_identifier", email);
        toast.info("Please verify your account with OTP");
        setTimeout(() => {
          navigate("/instructor-verification", {
            state: { login_identifier: email },
            replace: true,
          });
        }, 600);
        return;
      }

      // Profile Incomplete (OTP verified, but activation pending)
      if (user.is_active === 0 && user.is_otp_verification === 1) {
        sessionStorage.setItem("login_identifier", email);
        sessionStorage.setItem("instructor_id", user.instructor_id);
        sessionStorage.setItem("H7Z4L9VD2XK5JW8QRYT6", "pending_activation");
        if (user.mobile_number) {
          sessionStorage.setItem("instructor_mobile", user.mobile_number);
        }

        const encodedId = btoa(user.instructor_id.toString());
        toast.info("Please complete your profile");
        setTimeout(() => {
          navigate(
            `/instructor-panel/edit-instructor?id=${encodeURIComponent(encodedId)}`,
            { replace: true }
          );
        }, 600);
        return;
      }
    }

    // Fallback (should never reach here)
    toast.error("Unexpected response. Please try again.");
    setIsLoading(false);

  } catch (error) {
    console.error("Login error:", error);
    toast.error("Network error. Please check your connection.");
    setIsLoading(false);
  }
};
  return (
    <div className="min-h-screen w-full bg-white flex items-center justify-center px-4 py-6">
        <button
    onClick={() => window.history.back()}
    className="fixed top-10 left-4 z-50 flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-lg hover:shadow-xl transition-all border border-gray-200 dark:bg-gray-800 dark:border-gray-700"
    aria-label="Go back"
  >
    <FaArrowLeft className="text-2xl text-[#103b6b] dark:text-white" />
  </button>
      <div className="w-full max-w-7xl min-h-[650px] flex flex-col md:flex-row rounded-3xl overflow-hidden shadow-lg">

        <div className="w-full md:w-1/2 h-64 md:h-auto relative">
          <img 
            src={loginbg} 
            alt="Instructor Background" 
            className="absolute inset-0 w-full h-full object-cover" 
          />
          <div className="absolute inset-0 bg-black bg-opacity-30" />
          <div className="relative z-10 flex items-center justify-center h-full">
            {/* Clickable Logo */}
            <div
              onClick={() => navigate("/", { replace: true })}
              className="cursor-pointer transition-transform duration-200 hover:scale-105"
              title="Go to Home"
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && navigate("/", { replace: true })}
            >
              <img src={logo} alt="Logo" className="w-40 md:w-64" />
            </div>
          </div>
        </div>

        {/* Right Side - Form */}
        <div className="w-full md:w-1/2 bg-white flex items-start justify-center pt-6 px-6 md:px-10">
          <div className="w-full max-w-md">
            <div className="flex items-center mb-4 md:mb-6 justify-center md:justify-start">
              <FaUserCircle className="text-blue-900 text-[28px] md:text-[32px] mr-2 md:mr-3" />
              <span className="text-[18px] md:text-[22px] font-semibold text-blue-900 font-inter">
                INSTRUCTOR PORTAL
              </span>
            </div>

            <h2 className="text-[32px] md:text-[55px] font-bold text-blue-900 mb-4 md:mb-6 text-center font-inter">
              Welcome!
            </h2>

            <form className="space-y-5 md:space-y-6" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 font-inter mb-1">
                  Email
                </label>
               <div className="relative">
                  <input
                    type="text"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 pl-10 bg-white text-gray-900"
                    required
                    disabled={isLoading}
                  />
                  <MdEmail className="absolute left-3 top-2/4 transform -translate-y-1/2 text-gray-400 text-xl" />
                </div>
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700 font-inter mb-1">
                  Password
                </label>
                <div className="relative">
                  <input
                    type={passwordVisible ? "text" : "password"}
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Enter your password"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 pl-10 pr-10 bg-white text-gray-900"
                    required
                    disabled={isLoading}
                  />
                  <RiLockPasswordFill className="absolute left-3 top-2/4 transform -translate-y-1/2 text-gray-400 text-xl" />

                  <button
                    type="button"
                    onClick={() => setPasswordVisible((prev) => !prev)}
                    className="absolute right-3 top-2/4 transform -translate-y-1/2 text-gray-400 text-xl focus:outline-none"
                    tabIndex={-1}
                  >
                    {passwordVisible ? <AiFillEyeInvisible /> : <AiFillEye />}
                  </button>
                </div>
                <div className="text-right mt-1">
                  <a
                    href="/instructor-verification"
                    className="text-sm text-blue-900 hover:underline font-inter"
                  >
                    Forgot Password?
                  </a>
                </div>
              </div>

              <button
                type="submit"
                disabled={isLoading}
                className="w-full py-3 bg-blue-900 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-md transition duration-200 font-inter disabled:opacity-50"
              >
                {isLoading ? "Logging in..." : "Login"}
              </button>
            </form>

            <p className="mt-6 text-sm text-center text-gray-600 font-inter mb-4 md:mb-[5%]">
              Not a member?{" "}
              <a 
                href="/instructor-signup" 
                className="text-blue-900 font-medium hover:underline font-inter"
              >
                sign up
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstructorLogin;